import React from 'react';
import { getCurrencySymbol } from 'app/BargainWidget/Bargains/utils/currency-utils';
import { convertPrice } from 'app/BargainWidget/Bargains/utils/bargain-utils';

const BargainProductInfoV1 = ({ imageURL, title, price, offerPrice, translation, widgetSettings, className = '', bargainRule }) => {
  const calculateSavings = (originalPrice: number, offerPrice: number): string => {
    if (offerPrice >= originalPrice) {
      return '0.00';
    }
    let percentageSaved = ((originalPrice - offerPrice) / originalPrice) * 100;
    return percentageSaved.toFixed(2);
  };

  return (
    <div className={`se-flex se-gap-3 se-items-center se-flex-nowrap bargain-widget-v1-product-information ${className}`}>
      <div className="se-relative se-w-14 se-h-16 se-rounded-2xl se-overflow-hidden se-flex-shrink-0 bargain-widget-v1-product-image-container">
        <img src={imageURL} alt={title} className="se-object-contain se-w-full se-h-full bargain-widget-v1-product-image" />
      </div>
      <div className="se-flex se-flex-col bargain-widget-v1-product-description">
        <div className="se-text-sm se-font-semibold se-text-gray-800 se-mb-0.5 se-whitespace-normal bargain-widget-v1-product-info-title">
          {title}
        </div>
        <div className="se-flex se-gap-3 bargain-widget-v1-product-info-description">
          <div className="se-text-base se-font-bold se-text-gray-800 bargain-widget-v1-product-info-price">
            <span className="bargain-widget-v1-product-info-price-currency">{getCurrencySymbol()}</span>
            <span className="bargain-widget-v1-product-info-price-amount">{convertPrice(bargainRule, price)?.toLocaleString() || 0}</span>
          </div>
          <div
            style={
              {
                '--badge-background-color': widgetSettings?.headerBackgroundColor || '#000000',
                '--badge-text-color': widgetSettings?.contentTextColor || '#ffffff',
              } as any
            }
            className="se-inline-flex se-items-center se-justify-center se-bg-[var(--badge-background-color)] se-text-[var(--badge-text-color)] se-text-[10px] se-font-semibold se-px-2 se-py-0.5 se-rounded-lg se-shadow-lg bargain-widget-v1-product-info-saved-data"
          >
            {translation?.savedLabel?.replace('{{amount}}', calculateSavings(price, offerPrice)) ||
              `Save ${calculateSavings(price, offerPrice)}%`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BargainProductInfoV1;
